import * as types from './types';

export default {
    [types.SET_BANK_DATA](state, data) {
        state.bankData = data;
    }
};